/**
 * Global `interlucent` DevTools namespace.
 *
 * Creates (or reuses) `globalThis.interlucent` and exposes helpers
 * for other packages to register properties and versions.
 *
 * Usage:
 *   import { expose, registerVersion } from '@interlucent/global';
 *   expose('setLogLevel', setLogLevel);
 *   registerVersion('pixel-stream', '1.2.3');
 *
 * In DevTools:
 *   interlucent.setLogLevel('debug')
 *   interlucent.versions['pixel-stream']  // '1.2.3'
 */
var _a;
// Initialise the namespace once — this is the only side-effect.
const ns = ((_a = globalThis).interlucent ?? (_a.interlucent = {}));
// Lazily create the read-only `versions` sub-object on first registration.
function ensureVersions() {
    if (!ns.versions) {
        const versions = {};
        Object.defineProperty(ns, 'versions', {
            value: versions,
            writable: false,
            enumerable: true,
            configurable: false,
        });
    }
    return ns.versions;
}
/** Add a property to the global `interlucent` namespace. */
export function expose(key, value) {
    ns[key] = value;
}
/**
 * Register a package version under `interlucent.versions[name]`.
 * Each entry is frozen (non-writable, non-configurable) once set.
 */
export function registerVersion(name, version) {
    const versions = ensureVersions();
    if (!Object.getOwnPropertyDescriptor(versions, name)) {
        Object.defineProperty(versions, name, {
            value: version,
            writable: false,
            enumerable: true,
            configurable: false,
        });
    }
}
